import { useEffect } from 'react';
import { SaveButtonState } from '../../components/blackrock/advisor-center/save/SaveButtonProps';
import { isSsr } from '../isSsr';
import {
	sendSaveButtonDataLinkEvent,
	sendVoteDataLinkEvent,
} from '../../components/blackrock/advisor-center/_helpers/dataLinkEventHelper.ts';

/**
 * You must use this custom hook in any 'Save' feature related component (cwp entry component) that is available to non-logged-in users and in which a delayed, logged-in only function is available!
 * This hook handles the pending data-link-event in case the user has requested an action while they are not logged in (and the system made them login and do the action)
 */
export const usePendingSaveDataLinkEventHandler = (
	pendingDataLinkEvent?: string
) => {
	if (isSsr()) return;

	useEffect(() => {
		if (pendingDataLinkEvent) {
			sendSaveButtonDataLinkEvent(pendingDataLinkEvent, SaveButtonState.SAVED);
		}
	}, [pendingDataLinkEvent]);
};

/**
 * You must use this custom hook in any 'Poll' feature related component (cwp entry component) that is available to non-logged-in users and in which a delayed, logged-in only function is available!
 * This hook handles the pending data-link-event in case the user has requested an action while they are not logged in (and the system made them login and do the action)
 */
export const usePendingVoteDataLinkEventHandler = (
	pendingDataLinkEvent: string | undefined
) => {
	if (isSsr()) return;

	useEffect(() => {
		if (pendingDataLinkEvent) {
			sendVoteDataLinkEvent(pendingDataLinkEvent);
		}
	}, [pendingDataLinkEvent]);
};
